import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppService } from '../../services/app.service';
import { VaccinationDocumentService } from '../../services/vaccination-document.service';
import { IVaccinationDocument } from '../../models/VaccinationDocument';

@Component({
    selector: 'app-vaccination-document-form',
    templateUrl: './form.component.html'
})
export class VaccinationDocumentFormComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: VaccinationDocumentService,
        private route: ActivatedRoute
    ) { }

    document?: IVaccinationDocument;
    defaultTypeCode?: string;

    isReady: boolean;
    isEdit: boolean;

    ngOnInit() {
        const id = +this.route.snapshot.params['id'];        
        const canEdit = this.app.currentUser.hasRight('VACCINATION_DOCUMENT.EDIT');
        const canAdmin = this.app.currentUser.hasRight('VACCINATION_DOCUMENT.ADMIN');

        if (id) {
            this.app.addLoading(this.service.getById(id)).subscribe(data => {
                this.document = data;

                this.isEdit = canEdit && data.Status == 'Draft'
                    && (canAdmin || data.OwnerUserName == this.app.currentUser.username);

                this.isReady = true;
            });
        } else {
            const type = this.route.snapshot.queryParams['type'];

            if (type) {
                this.app.addLoading(this.service.getMyStatus()).subscribe(data => {
                    const draft = data.find(t => t.Type.toLowerCase() == type.toLowerCase() && t.Status == 'Draft');

                    if (draft) {
                        this.app.navigate([`/vaccination-documents`, draft.Id]);
                    } else {
                        this.defaultTypeCode = type;
                    }

                    this.isEdit = true;
                    this.isReady = true;
                });
            } else {
                this.isEdit = true;
                this.isReady = true;
            }
        }
    }
}
